import { z } from 'zod'

export const PlanNetworkTypeEnum = {
  HMO: 'Health Maintenance Organization',
  PPO: 'Preferred Provider Organization',
  EPO: 'Exclusive Provider Organization',
  POS: 'Point of Services',
} as const
export const PlanNetworkTypeSchema = z.nativeEnum(PlanNetworkTypeEnum)
export type PlanNetworkType = z.infer<typeof PlanNetworkTypeSchema>

export const PlanAccountTypeEnum = {
  HSA: 'HSA',
  HDHP: 'HDHP',
  FSA: 'FSA',
  OTHER: 'OTHER',
} as const
export const PlanAccountTypeSchema = z.nativeEnum(PlanAccountTypeEnum)
export type PlanAccountType = z.infer<typeof PlanAccountTypeSchema>

export const MetalTierEnum = {
  BRONZE: 'Bronze',
  SILVER: 'Silver',
  GOLD: 'Gold',
} as const
export const MetalTierSchema = z.nativeEnum(MetalTierEnum)
export type MetalTier = z.infer<typeof MetalTierSchema>
